export interface BonusItem {
  title: string
  body: string
  value: string
  image: string
}

export const bonusItems: BonusItem[] = [
  {
    title: '500 Frases más usadas',
    body: '500 frases más usadas con su pronunciación. Aprende frases útiles para conversaciones, viajes, trabajo, mensajes y situaciones cotidianas.',
    value: '$9500',
    image: 'https://cdn.magicpatterns.com/uploads/qahrUqtnnzt5zMmAqLATcd/img1-500.png',
  },
  {
    title: 'English Practice Master Kit',
    body: '200 Ejercicios Prácticos A1–C2 + Respuestas.',
    value: '$15000',
    image: 'https://cdn.magicpatterns.com/uploads/2mpWtnTixrRH1k48vwWcUf/A1-C2.png',
  },
  {
    title: '100 Verbos Frasales Esenciales',
    body: '100 verbos más utilizados en inglés real, con su significado, ejemplos y aplicaciones cotidianas.',
    value: '$12500',
    image: 'https://cdn.magicpatterns.com/uploads/grEmVvoQcmUSkHstJJEHMq/100VERBOS.png',
  },
]
